import { observer } from "mobx-react-lite";
import Layout, { Body, Item, Footer, Control } from "../cmp/layout";
import Field from "../cmp/field";
import Button from "../cmp/button";
import useNav from "../hook/nav";
import useReset from "./hook";
import Think from "../cmp/think";

function Reset() {
	const { login } = useNav();
	const { wait, log, em, err, submit } = useReset();
	const idx = [wait, err].findIndex(e => e);
	return <Layout id='reset' title='Сброс пароля'>
		<Body>
			<Item>
				<Field autoComplete='username' disabled={wait} type='layer1' label='Логин' icon='user' placeholder='Введите логин' {...log} />
			</Item>
			<Item>
				<Field autoComplete='email' disabled={wait} type='layer1' label='Электронная почта' icon='mail' placeholder='Введите почту' {...em} />
			</Item>
		</Body>
		<Control center>
			<Button disabled={wait} type='base-reverse' onClick={login}>Назад</Button>
			<Button disabled={wait} type='base' onClick={submit}>Сбросить</Button>
		</Control>
		<Footer>
			{idx === -1 && <span>На указанную почту будет выслано письмо с новым паролем</span>}
			{idx === 0 && <span><Think fq={700} text='Отправляем код на почту' /></span>}
			{idx === 1 && <span style={{color: 'var(--error)'}}>Ошибка: {err.toString()}</span>}
		</Footer>
	</Layout>
}

export default observer(Reset)